module.exports = __webpack_public_path__ + "img/自动化营销工具.95cbfe41.png";